import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { useTranslation } from "react-i18next";

export function FindDialog({visible,onCommand,onCancel})
{    
    const {t} = useTranslation();      
    const [searchInfo,setSearchInfo]=useState({search:"",replace:"",upward:false,caseSensitive:false});

    const onChange=(formData)=>{        
        setSearchInfo(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onCommand=(cmd)=>{
        onCommand(cmd,searchInfo);
    }
    const renderFooter=()=>{
        return (
            <div>
                <Button label={t('Editor.Close')} icon="pi pi-times" onClick={onCancel} className="p-button-text" />
                <Button label={t('Editor.Find')} onClick={()=>_onCommand('find')} autoFocus />
                <Button label={t('Editor.Replace')} onClick={()=>_onCommand('replace')} autoFocus />
                <Button label={t('Editor.Replace_All')} onClick={()=>_onCommand('replaceall')} autoFocus />
            </div>
        );
    }	    

    useEffect(()=>{
    },[]);
    return(
        <>
        <Dialog header={t('Editor.Find_and_replace')} visible={visible} footer={renderFooter}>
            <div className="p-2" style={{maxWidth:'400px'}}>
            <Form id="find" formData={searchInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"search",ftype:"text",field:"search",label:t('Editor.Search_for')},
                    {id:"replace",ftype:"text",field:"replace",label:t('Editor.Replace_By')},                
                    {id:"upward",ftype:"checkbox",field:"upward",label:t('Editor.Backward')},
                    {id:"caseSensitive",ftype:"checkbox",field:"caseSensitive",label:t('Editor.Case_Sensitive')}
                ]}>
            </Form>	
            </div>
        </Dialog>
        </>
    );
}